import React, { useMemo } from 'react';
import { Typography } from 'antd';
import { TruncatedText } from '@spark';
import { groupOriginInfos, getOriginTooltip, OriginGroupLabel } from './originDisplay';

const { Text } = Typography;

export default function ModelDetailsOriginsSection({ title, origins }) {
  const originGroups = useMemo(() => groupOriginInfos(origins), [origins]);

  return (
    <div style={{ marginTop: 10, marginBottom: 14 }}>
      <Text style={{ color: '#9CA3AF', fontSize: 12 }}>{title}</Text>
      {originGroups.length > 0 ? (
        <div style={{ marginTop: 6, fontSize: 12, display: 'grid', rowGap: 6 }}>
          {originGroups.map((g) => (
            <div key={g.label} style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
              <Text strong>{g.label}:</Text>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {g.items.map((it, idx) => {
                  // For Files + SpecificAI items, tooltip should describe the origin (not repeat the name).
                  const tooltipTitle =
                    g.label === OriginGroupLabel.files || g.label === OriginGroupLabel.specificAi
                      ? getOriginTooltip(it.origin)
                      : undefined; // default tooltip = full name (useful when truncated)

                  return (
                    <span
                      key={`${g.label}-${it.name}-${idx}`}
                      style={{ cursor: tooltipTitle ? 'help' : 'default' }}
                    >
                      <TruncatedText
                        text={it.name}
                        tooltipText={tooltipTitle}
                        maxWidth={360}
                        style={{ fontSize: 12, display: 'inline-block' }}
                      />
                    </span>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div style={{ marginTop: 6, fontSize: 12 }}>
          <Text>—</Text>
        </div>
      )}
    </div>
  );
}

